import { isEmpty, isNumber, isNaN } from 'lodash-es'
/**
 * Extracts digits from given string and formats it as a typical 10-digital US phone number with dashes (###-###-####)
 *
 * @param {String} dirtyNumber Any input string
 * @returns {String} The formatted number
 */
export function formatPhoneNumber(dirtyNumber) {
  if ((isEmpty(dirtyNumber) && !isNumber(dirtyNumber)) || !isNumber(dirtyNumber) || isNaN(dirtyNumber)) {
    return ''
  }

  const cleanValue = digitsFromString(dirtyNumber)
  let formattedValue

  const first = cleanValue.substring(0, 3)
  const second = cleanValue.substring(3, 6)
  const third = cleanValue.substring(6)

  if (cleanValue.length <= 3) {
    formattedValue = cleanValue
  } else if (third) {
    formattedValue = `${first}-${second}-${third}`
  } else if (second) {
    formattedValue = `${first}-${second}`
  } else if (first) {
    formattedValue = first
  }

  return formattedValue
}

export function digitsFromString(dirtyNumber) {
  if (isEmpty(dirtyNumber) && !isNumber(dirtyNumber)) {
    return ''
  }

  if (isNumber(dirtyNumber)) {
    // if it's a number... return it as a string
    return String(dirtyNumber)
  }

  const digits = dirtyNumber.match(/\d+/g)
  let returnValue = dirtyNumber

  if (digits) {
    returnValue = digits.map(String).join('')
  }

  return Number.parseInt(returnValue)
}
